import { render, staticRenderFns } from "./TargetDetail.vue?vue&type=template&id=0154d79c&scoped=true&"
import script from "./TargetDetail.vue?vue&type=script&lang=js&"
export * from "./TargetDetail.vue?vue&type=script&lang=js&"
import style0 from "./TargetDetail.vue?vue&type=style&index=0&id=0154d79c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0154d79c",
  null
  
)

export default component.exports